var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('van-nav-bar',{attrs:{"title":_vm.$t('page.financialRecord')}},[_c('van-icon',{attrs:{"slot":"left","name":"arrow-left","color":"#fff"},on:{"click":function($event){return _vm.$router.back()}},slot:"left"})],1),_c('FinancialRecord')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }